let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1e3U5")).then(() => parcelRequire('cYXPO'));